import isEqual from 'react-fast-compare';

import {toJS} from 'mobx';

import type {
  EditionApiModel,
  ProgramExpandedCommon,
} from '../../../api/program';
import type {Nullable} from '../../utility-types';

import {not} from '../../conditionalUtils';

const prepareEditions = (editions: EditionApiModel[]) =>
  editions.filter(Boolean).map(edition => {
    const editionCopy = {...edition};

    editionCopy.conferences = editionCopy.conferences?.map(conference => {
      const copy = {...conference};

      // @ts-expect-error: TODO: describy why
      delete copy.repeat;
      // @ts-expect-error: TODO: describy why
      // since we group and un-group conferences we change edition uuid
      // so exclude it from comparison
      delete copy.edition_uuid;

      return copy;
    });

    editionCopy.tasks = editionCopy.tasks?.map(task => {
      const copy = {...task};

      // @ts-expect-error: TODO: describy why
      delete copy.edition_uuid;

      return copy;
    });

    return editionCopy;
  });

const removeUndefinedFields = <T extends object>(obj: T) => {
  const result = {...obj};

  Object.keys(result).forEach(key => {
    if (result[key] === undefined) {
      delete result[key];
    }
  });

  return result;
};

export const isProgramDirty = (
  program: Nullable<ProgramExpandedCommon> | undefined,
  originalProgram: Nullable<ProgramExpandedCommon> | undefined,
) => {
  const programA = toJS(originalProgram) || {
    editions: [],
  };
  const programB = toJS(program) || {
    editions: [],
  };

  // @ts-expect-error: TODO: describy why
  programA.editions = prepareEditions(programA.editions);
  // @ts-expect-error: TODO: describy why
  programB.editions = prepareEditions(programB.editions);

  // We should exclude expanded_coaches from comparing because they aren't synced (last_seen and updated_at),
  // but we still compare coaches ids
  // We have to remove undefined fields, because fields _id and revision can be 'undefined' in programB,
  // but there aren't in programA
  const programAToCompare = removeUndefinedFields({
    ...programA,
    expanded_coaches: undefined,
  });
  const programBToCompare = removeUndefinedFields({
    ...programB,
    expanded_coaches: undefined,
  });

  return not(isEqual(programAToCompare, programBToCompare));
};
